import { useMemo } from 'react';

import { parseMarkdown } from '@modules/_shared/utils/parseMarkdown';

const MarkdownParser: React.FC<{
  markdown: string;
  disableLinks?: boolean;
}> = ({ markdown, disableLinks = false }) => {
  const html = useMemo(
    () => parseMarkdown(markdown, { disableLinks, disableCode: true }),
    [markdown, disableLinks],
  );

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default MarkdownParser;
